import { useLocale } from '../i18n'

function AboutPage() {
  const { t } = useLocale()
  const trackerDomain = import.meta.env.VITE_TRACKER_DOMAIN || 'https://example.com'
  const providerCode = new URLSearchParams(window.location.search).get('provider_code') || 'YOUR_PROVIDER_CODE'

  const SETUP = `${t('docs.setupHint')}
<script src="${trackerDomain}/dc.min.js?provider_code=${providerCode}"></script>`
  const ADD_TO_CART_BUTTON = `<button id="add-to-cart-btn">
  ${t('products.add')}
</button>`
  const ADD_TO_CART = `<script>
  document
    .getElementById('add-to-cart-btn')
    .addEventListener('click', function () {
      DC.addToCart({
        items: [
          {
            item_id: 'product_1',
            item_name: 'iPhone 15 Pro',
            quantity: 1,
            price: 36900,
            total_price: 36900
          },
          {
            item_id: 'product_3',
            item_name: 'AirPods Pro',
            quantity: 1,
            price: 7490,
            total_price: 7490
          }
        ]
      });

    });
</script>
`
  const CHECKOUT_BUTTON = `<button id="purchase-btn">
  ${t('cart.checkout')}
</button>`
  const CHECKOUT = `<script>
  document
    .getElementById('purchase-btn')
    .addEventListener('click', function () {
      DC.checkout({
        order_id: 'order_12345',
        total_price: 44390,
        shipping_cost: 0,
        items: [
          {
            item_id: 'product_1',
            item_name: 'iPhone 15 Pro',
            quantity: 1,
            price: 36900,
            total_price: 36900
          },
          {
            item_id: 'product_3',
            item_name: 'AirPods Pro',
            quantity: 1,
            price: 7490,
            total_price: 7490
          }
        ]
      });
    });
</script>`

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {})
  }
  return (
    <div className='content'>
      <h2 className='page-title'>{t('docs.title')}</h2>

      <div className='demo-section'>
        <h3>{t('docs.how')}</h3>
        <div className='config-title'>
          <h4 className='doc-title'>{t('docs.install')}</h4>
          <button
            className='demo-button secondary small'
            onClick={() => handleCopy(SETUP)}
          >
            {t('docs.copy')}
          </button>
        </div>
        <div className='config-display'>{SETUP}</div>
        <br />
        <h4 className='doc-title'>{t('docs.addEvent')}</h4>
        <h4>{t('docs.params')}</h4>
        <div className='table-container'>
          <table className='field-table'>
            <thead>
              <tr>
                <th>{t('docs.tableHeaders.field')}</th>
                <th>{t('docs.tableHeaders.type')}</th>
                <th>{t('docs.tableHeaders.required')}</th>
                <th>{t('docs.tableHeaders.desc')}</th>
                <th>{t('docs.tableHeaders.example')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>items</td>
                <td>Array</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.cartDesc')}<span className='import-hint'>{t('docs.cartHint')}</span></td>
                <td>[{'{...}'}]</td>
              </tr>
              <tr>
                <td>items.item_id</td>
                <td>String</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.itemId')}</td>
                <td>&quot;product_1&quot;</td>
              </tr>
              <tr>
                <td>items.item_name</td>
                <td>String</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.itemName')}</td>
                <td>&quot;iPhone 15 Pro&quot;</td>
              </tr>
              <tr>
                <td>items.quantity</td>
                <td>Number</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.quantity')}</td>
                <td>1</td>
              </tr>
              <tr>
                <td>items.price</td>
                <td>Number</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.price')}</td>
                <td>36900</td>
              </tr>
              <tr>
                <td>items.total_price</td>
                <td>Number</td>
                <td>{t('docs.optional')}</td>
                <td>{t('docs.totalPrice')}</td>
                <td>36900</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className='config-title'>
          <h4>{t('docs.exampleLabel')}</h4>
          <button
            className='demo-button secondary small'
            onClick={() => handleCopy(ADD_TO_CART)}
          >
            {t('docs.copy')}
          </button>
        </div>
        <div className='config-display'>{ADD_TO_CART_BUTTON}</div>
        <div className='config-display'>{ADD_TO_CART}</div>
        <br />
        <h4 className='doc-title'>{t('docs.checkoutEvent')}</h4>
        <h4>{t('docs.checkoutParams')}</h4>
        <div className='table-container'>
          <table className='field-table'>
            <thead>
              <tr>
                <th>{t('docs.tableHeaders.field')}</th>
                <th>{t('docs.tableHeaders.type')}</th>
                <th>{t('docs.tableHeaders.required')}</th>
                <th>{t('docs.tableHeaders.desc')}</th>
                <th>{t('docs.tableHeaders.example')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>order_id</td>
                <td>String</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.orderId')}</td>
                <td>&quot;order_12345&quot;</td>
              </tr>
              <tr>
                <td>total_price</td>
                <td>Number</td>
                <td>{t('docs.optional')}</td>
                <td>
                  {t('docs.orderTotal')}
                </td>
                <td>44390</td>
              </tr>
              <tr>
                <td>shipping_cost</td>
                <td>Number</td>
                <td>{t('docs.optional')}</td>
                <td>{t('docs.shippingCost')}</td>
                <td>0</td>
              </tr>
              <tr>
                <td>items</td>
                <td>Array</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.cartDesc')}<span className='import-hint'>{t('docs.cartHint')}</span></td>
                <td>[{'{...}'}]</td>
              </tr>
              <tr>
                <td>items.item_id</td>
                <td>String</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.itemId')}</td>
                <td>&quot;product_1&quot;</td>
              </tr>
              <tr>
                <td>items.item_name</td>
                <td>String</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.itemName')}</td>
                <td>&quot;iPhone 15 Pro&quot;</td>
              </tr>
              <tr>
                <td>items.quantity</td>
                <td>Number</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.quantity')}</td>
                <td>1</td>
              </tr>
              <tr>
                <td>items.price</td>
                <td>Number</td>
                <td>{t('docs.required')}</td>
                <td>{t('docs.price')}</td>
                <td>36900</td>
              </tr>
              <tr>
                <td>items.total_price</td>
                <td>Number</td>
                <td>{t('docs.optional')}</td>
                <td>{t('docs.totalPrice')}</td>
                <td>36900</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='config-title'>
          <h4>{t('docs.exampleLabel')}</h4>
          <button
            className='demo-button secondary small'
            onClick={() => handleCopy(CHECKOUT)}
          >
            {t('docs.copy')}
          </button>
        </div>
        <div className='config-display'>{CHECKOUT_BUTTON}</div>
        <div className='config-display'>{CHECKOUT}</div>
      </div>
    </div>
  )
}

export default AboutPage
